import React, { useRef, useEffect } from 'react';

interface User {
  id: string;
  first_name: string;
  last_name: string;
  user_code: string;
}

interface MentionDropdownProps {
  users: User[];
  selectedIndex: number;
  onSelect: (user: User) => void;
  loading?: boolean;
}

const MentionDropdown: React.FC<MentionDropdownProps> = ({
  users,
  selectedIndex,
  onSelect,
  loading = false
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectedIndex >= 0) {
      const dropdown = dropdownRef.current;
      const selectedItem = dropdown?.children[selectedIndex] as HTMLElement;
      if (selectedItem && dropdown) {
        selectedItem.scrollIntoView({ block: 'nearest' });
      }
    }
  }, [selectedIndex]);

  return (
    <div 
      ref={dropdownRef} 
      className="absolute bottom-full left-4 mb-2 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto z-50 scrollBar"
    >
      {loading ? (
        <div className="px-3 py-2 flex items-center gap-2">
          <div className="w-4 h-4 border-2 border-p_primary border-t-transparent rounded-full animate-spin"></div>
          <span className="text-sm text-gray-500">Loading users...</span>
        </div>
      ) : users.length > 0 ? (
        users.map((user, index) => (
          <div
            key={user.id || index}
            className={`px-3 py-2 cursor-pointer flex items-center gap-2 ${
              index === selectedIndex ? 'bg-blue-100' : 'hover:bg-gray-100'
            }`}
            onClick={() => onSelect(user)}
          >
            <div className="w-8 h-8 bg-p_primary text-white rounded-full flex items-center justify-center text-xs font-medium">
              {user.first_name?.[0] || '-'}{user.last_name?.[0] || '-'}
            </div>
            <div className="flex-1">
              <div className="text-sm font-medium">{user.first_name || '-'} {user.last_name || '-'}</div>
              <div className="text-xs text-gray-500">{user.user_code || '-'}</div>
            </div>
          </div>
        ))
      ) : (
        <div className="px-3 py-2 text-sm text-gray-500">
          No users found
        </div>
      )}
    </div>
  );
};

export default MentionDropdown;